import { DESKTOP_MAX_SIZE } from "@/constants/screen";
import styled from "styled-components";

export const Backdrop = styled.div<{
  $isVisible: boolean;
}>`
  position: fixed;
  inset: 0;
  z-index: 10;
  align-items: center;
  justify-content: center;
  display: grid;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;

export const ModalWrapper = styled.div<{ $isFullScreen: boolean }>`
  width: 100%;
  height: 100%;
  padding: ${({ theme, $isFullScreen }) => ($isFullScreen ? 0 : theme.spacers.L)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  @media (${({ theme }) => theme.screens.tablet}) {
    max-width: ${DESKTOP_MAX_SIZE};
    justify-self: anchor-center;
    padding: 0;
  }
`;

export const ModalContent = styled.div<{
  $isVisible: boolean;
  $isFullScreen: boolean;
}>`
  background: ${({ theme }) => theme.colors.background.white};
  border-radius: ${({ theme, $isFullScreen }) => ($isFullScreen ? 0 : theme.borderRadius.S)};
  box-shadow: ${({ theme }) => theme.shadows.normal};
  width: 100%;
  z-index: 12;
  height: ${({ $isFullScreen }) => ($isFullScreen ? "100dvh" : "auto")};
  position: relative;
  padding: ${({ theme }) => theme.spacers.L};
  transform: ${({ $isVisible }) => ($isVisible ? "scale(1)" : "scale(0.95)")};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;
